import { subjectQueryAsync } from 'helpers/graphql'
import _ from 'lodash';

export default () => {
  const query = `
    query {
      subjects(
        isForMember: true
        type: "coding"
      ) {
        count
        data {
          id
        }
      }
    }
  `
  return subjectQueryAsync(query)
  .then((body) => {
      localStorage.subjetcId = _.get(body.data.subjects, 'data[0].id')
    }
  );
};



/** WEBPACK FOOTER **
 ** ./src/app/helpers/fetchSubjectId.js
 **/